import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import 'rxjs/add/operator/map';

import { Transaction } from './transaction.model';
import { TransactionService } from './transaction.service';

@Injectable()
export class TransactionResolver implements Resolve<Transaction> {
  constructor(private transactionCodeService: TransactionService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Transaction> {
    return this.transactionCodeService.getById(route.paramMap.get('transactionId'));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/transactions/transaction.resolver.ts